---
layout: docs
title: "The Canvas"
---


The canvas is a visual workspace that appears alongside conversations in the Hub. It renders charts, diagrams, code previews, documents, and generated UI in a unified panel.

---

## How It Works

The canvas activates automatically when the assistant produces visual content. You don't need to open or configure it — it appears when there's something to show.

All visual content flows through a single protocol. Whether the assistant generates a chart, a Mermaid diagram, an HTML interface, or a document preview, it renders in the same canvas panel.

---

## What the Canvas Displays

### Charts

Data visualizations generated from your data — bar charts, line charts, scatter plots, and more. The assistant creates these when analyzing data or when you ask for visual representations.

### Diagrams

Mermaid diagrams — flowcharts, sequence diagrams, entity relationship diagrams, architecture diagrams, and more. The assistant generates the diagram definition and the canvas renders it.

### Code and Documents

When the assistant writes code or documents to the file system, the canvas can render a preview. This gives you a live view of what's being created alongside the conversation.

### Generated UI

The assistant can create on-the-fly interfaces — interactive elements that go beyond static charts or text. This uses the same unified protocol and renders directly in the canvas.

<!-- TODO: Specific examples of generated UI capabilities — what kinds of interactive elements can the assistant create? Forms? Dashboards? Data tables? How does interactivity work — can the user interact with generated UI and have results flow back into the conversation? -->

*This section is a work in progress.*


---

## Canvas and Files

The canvas is connected to the file system. When the assistant writes a file that has a visual representation (a chart definition, a diagram, an HTML file), the canvas picks it up automatically. You can also ask the assistant to show a specific file in the canvas.
